import React, { useState } from 'react'
import { OverlayTrigger, Tooltip, Alert, Spinner } from 'react-bootstrap'
import axios from 'axios'
import { useGetCurrentAgentStatusQuery } from '../../../../redux/agentStatusApi'
import { useAuth } from '../../../../modules/auth/core/Auth'
import toaster from '../../../../../Utils/toaster'
const API_URL = process.env.REACT_APP_API_URL

interface CCPStatusButtonProps {
  text?: string
  appointmentId: number
  hasSessionStarted: boolean
  appointmentStartTime?: string
  className?: string
  source?: 'Calendar' | 'Viewer' | 'Reminder'
}

const CCPStatusButton: React.FC<CCPStatusButtonProps> = ({
  text = 'Start Session',
  appointmentId,
  appointmentStartTime,
  className = 'btn btn-sm ms-3',
  hasSessionStarted,
  source = 'Viewer'
}) => {
  const { auth, currentUser } = useAuth()
  // Skip API call for admin, requester (CONSUMER), and system users
  const { data: agentStatusData, isLoading } = useGetCurrentAgentStatusQuery(undefined, {
    skip: !auth?.isAuthenticated || !currentUser || currentUser.result?.userType === 'ADMIN' || currentUser.result?.userType === 'REQUESTER' || currentUser.result?.userType === 'CONSUMER' || currentUser.result?.userType === 'SYSTEM'
  })
  const [sessionActive, setSessionActive] = useState(hasSessionStarted)
  const [starting, setStarting] = useState(false)

  // Sync sessionActive with hasSessionStarted prop
  React.useEffect(() => {
    setSessionActive(hasSessionStarted)
  }, [hasSessionStarted])

  console.log('CCPStatusButton - sessionActive:', hasSessionStarted)
  // Determine if agent is available based on the response
  const isAgentAvailable = React.useMemo(() => {
    if (!agentStatusData) return false
    if (agentStatusData.status === '200' && agentStatusData.currentStatus) {
      return agentStatusData.currentStatus.type === 'ROUTABLE'
    }
    return false
  }, [agentStatusData])

  const handleStartSession = async () => {
  try {
    setStarting(true)

    const response = await axios.post(
      `${API_URL}/Appoinment/start-session/${appointmentId}`,
      { Source: source }
    )

    // SUCCESS (2xx)
    if (response.data.status === 'S') {
      toaster('success', 'Successfully updated')
      setSessionActive(true)
    }
  } catch (error: any) {
    console.error('Error starting session:', error)

    // 👇 HANDLE BACKEND ERROR RESPONSE (403, 400, etc)
    if (error.response?.data) {
      const { status, text } = error.response.data

      if (status === 'E') {
        toaster('error', text)
      } else {
        toaster('error', 'Failed to start session')
      }
    } else {
      toaster('error', 'Network error. Please try again.')
    }

    setSessionActive(false)
  } finally {
    setStarting(false)
  }
}




  const button = (
    <button
      className={`${className} ${sessionActive ? 'btn-success' : !isAgentAvailable ? 'btn-secondary' : 'btn-primary'}`}
      onClick={isAgentAvailable && !sessionActive ? handleStartSession : undefined}
    >
      {isLoading ? 'Checking...' : sessionActive ? 'Session Active' : text }
    </button>
  )

  if (!isAgentAvailable) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>Please login to CCP to start session</Tooltip>}
      >
        {button}
      </OverlayTrigger>
    )
  }

  return button
}

export default CCPStatusButton
